import { styled } from '@mui/material';

import { TAiPageChatMessageDto } from '@app-velocity/av-api-v2';
import { getDiscussionAnswer } from '@app-velocity/common';

export type HistoryProps = {
  messages: TAiPageChatMessageDto[];
};

const StyledUserQuestion = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(2),
  padding: theme.spacing(4),
  marginBottom: theme.spacing(2),
  backgroundColor: 'var(--color-blue-200)',
  marginLeft: theme.spacing(8),
  fontSize: 11,
}));

const StyledAiAnswer = styled('div')(({ theme }) => ({
  borderRadius: theme.spacing(2),
  padding: theme.spacing(4),
  marginBottom: theme.spacing(2),
  backgroundColor: 'var(--color-neutral-300)',
  marginRight: theme.spacing(8),
  fontSize: 11,
}));

export const History = ({ messages }: HistoryProps) => {
  const userAndAssistantMessages = messages.filter((message) =>
    ['USER', 'ASSISTANT'].includes(message.messageType!)
  );

  return (
    <>
      {userAndAssistantMessages.map((item, index) =>
        item.messageType === 'USER' ? (
          <StyledUserQuestion key={index}>
            {item.originalMessage}
          </StyledUserQuestion>
        ) : (
          <StyledAiAnswer key={index}>
            {getDiscussionAnswer(item.content || '')}
          </StyledAiAnswer>
        )
      )}
    </>
  );
};
